export const blockedNoticeWrapperSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  width: '100%',
  height: '100%',
  padding: '24px',
  textAlign: 'center',
};

export const blockedNoticeBodySx = {
  maxWidth: 420,
};
